import React from "react";
import {getStore} from "../../reducers/cart_icon_reducer";
import {Provider} from "react-redux";
import Cart from "./Cart";

const CartWithProvider = (props) => {
  return (
    <Provider store={getStore(props)}>
      <Cart {...props}/>
    </Provider>
  );
};

export default CartWithProvider;